import * as React from 'react'
import type { SVGProps, Ref } from 'react'
import { forwardRef } from 'react'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgArrowLeft = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 24 24'
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill={props.color}
      fillRule='evenodd'
      d='M20.571 12a1.5 1.5 0 0 1-1.5 1.5H8.551l4.51 4.51a1.5 1.5 0 0 1-2.122 2.122L3.87 13.06a1.5 1.5 0 0 1 0-2.122l7.07-7.07a1.5 1.5 0 1 1 2.122 2.12L8.55 10.5h10.52a1.5 1.5 0 0 1 1.5 1.5'
      clipRule='evenodd'
    />
  </svg>
)
const ForwardRef = forwardRef(SvgArrowLeft)
export default ForwardRef
